import * as React from "react";
// import { MapAjax } from "@syncfusion/ej2-maps";
import {
  MapsComponent,
  Inject,
  LayersDirective,
  LayerDirective,
  MapsTooltip,
  Legend,
} from "@syncfusion/ej2-react-maps";
// import { updateSampleSection } from "../common/sample-base";
// import * as data from "./map-data/tooltip-datasource.json";
// import features from "../src/world-map.json";
import features from "../../world-map.json";
import { salseData } from "../world-map";
import { Box, Grid, Stack, Typography } from "@mui/material";
// import React from "react";
// import * as React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Images } from "../../assets/common";
import States from "../State";
import "./index.scss";
import NoData from "../Nodata";
import { useTranslation } from "react-i18next";
import MapPopup from "../MapPopup";
const SAMPLE_CSS = `
   `;
export default function Map({ main, padd, data, location, tab }) {
  const { t } = useTranslation("common");
  const [viewPopup, setViewPopup] = React.useState(false);

  // console.log(tab, "::tab::");

  // function onMapsLoad(args) {
  //   let maps = document.getElementById("maps");
  //   maps.setAttribute("title", "");
  // }
  function tooltipRender(args) {
    if (!args.options["data"]) {
      args.cancel = true;
    }
  }

  const handleClickOpen = () => {
    setViewPopup(true);
  };
  const handleClose = () => {
    setViewPopup(false);
  };
  return (
    <div
      className="control-pane"
      style={{
        margin: "6px",
        // background: "#262626",
        background: "#090909",
        borderRadius: "5px",
        padding: "20px",
        position: "relative",
        minHeight: "200px",
        height: tab === "Tips" ? "" : "417px",
        // height: tab === "Tips" ? "" : "457px",
      }}
    >
      {location.length > 0 ? (
        <Grid container spacing={2}>
          <Grid
            item
            xs={tab === "Tips" ? 6 : 0}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box>
              <MapsComponent
                height="210"
                // background="rgb(38, 38, 38)"
                background="#090909"
                width="400"
                tooltipRender={tooltipRender.bind(this)}
                // loaded={onMapsLoad.bind(this)}
                // load={(args) => load(args)}
              >
                <Inject services={[MapsTooltip, Legend]} />
                <LayersDirective
                  // background="rgb(38, 38, 38)"
                  background="#090909"
                >
                  <LayerDirective
                    shapeData={features}
                    dataSource={location}
                    shapePropertyPath="name"
                    shapeDataPath="name"
                    //   dataSource={salseData}
                    //   xName="Country"
                    //   yName="Membership"
                    tooltipSettings={{
                      visible: true,
                      valuePath: "name",
                      shapeDataPath: "Country",
                      template:
                        // '<div id="tooltemplate" style="width: 90px;background: rgba(53, 63, 76, 0.90); opacity: 90%;background: rgba(53, 63, 76, 0.90);box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.40);padding-bottom: 10px;padding-top: 10px;padding-left: 10px;padding-right: 10px;border: 1px #abb9c6">' +
                        // '<div style="font-size:13px;color:#ffffff;font-weight: 500;"><center>${country}</center></div>' +
                        // '<hr style="margin-top: 2px;margin-bottom:5px;border:0.5px solid #DDDDDD">' +
                        // '<div><span style="font-size:13px;color:#cccccc">Finalist : </span><span style="font-size:13px;color:#ffffff;font-weight: 500;">${value1}</span></div>' +
                        // '<div><span style="font-size:13px;color:#cccccc">Win : </span><span style="font-size:13px;color:#ffffff;font-weight: 500;">${value2}</span></div></div>',

                        '<div id="tooltemplate" style="width: 90px; height:28px; background: #FFFFFF; align-items:center; opacity: 90%;background: #FFFFFF;box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.40);padding-bottom: 5px;padding-top: 5px;padding-left: 5px;padding-right: 5px;border: 1px #abb9c6; border-radius: 8px; ">' +
                        '<div style="inline-size: fit-content;"><span style="font-size:14px;color:#262626">${country} :</span><span style="font-size:14px;color:#262626;">${value1}</span></div>',
                    }}
                    shapeSettings={{
                      fill: "gray",
                      colorMapping: [
                        {
                          color: "#F48706",
                        },
                      ],
                      colorValuePath: "country",
                    }}
                  ></LayerDirective>
                </LayersDirective>
              </MapsComponent>
            </Box>
          </Grid>
          <Grid
            item
            style={{ width: "100%", position: "relative", paddingTop: "0px" }}
            xs={tab === "Tips" ? 6 : 0}
          >
            <Box style={{ width: "100%" }}>
              <Box>
                <States data={data} location={location} />
              </Box>
              {location.length > 5 ? (
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ paddingTop: "5px", borderTop: "1px solid #707070" }}
                >
                  <Typography
                    onClick={handleClickOpen}
                    className="fs-14 canceled _cp"
                    style={{ fontSize: "14px", color: "#FFEE20" }}
                  >
                    {t("analytics.map.text1")}
                  </Typography>
                </Stack>
              ) : null}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <NoData lable={t("noDataToShow")} />
      )}
      {viewPopup ? (
        <MapPopup
          data={data}
          location={location}
          open={viewPopup}
          handleClose={(e) => {
            handleClose(e);
          }}
        />
      ) : null}
    </div>
  );
}
